import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getCalendar,
  postCalendar,
} from "../../redux/Actions/calendarAction";

import ContentBlock from "../Layout/ContentBlock";
import { AlertError } from "../common/Alerts";

class Calendar extends React.Component {
  constructor() {
    super();
    this.state = {
      offDays: [],
      currentYear: this.currentYear(),
      loaded: false,
    };

  }

  componentDidMount() {
    this.reloadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.offDays !== this.props.offDays
    ) {
      this.setState({ offDays: this.props.offDays });
    }
  }

  reloadData = (paramsFilter) => {
    this.props.getCalendar();
  };



  getMonths = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    return months;
  };

  getDaysInMonth = (month, year) => {
    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
      var day_date = new Date(date);
      var day = [day_date.getDate(), day_date.getDay() == 6 || day_date.getDay() == 0 ? true : false];
      days.push(day);
      date.setDate(date.getDate() + 1);
    }
    return days;
  };

  selectDays = (day) => {
    let days = this.state.offDays;

    for (var m = 0; m < 12; m++) {
      var days_in_month = new Date(this.state.currentYear, m + 1, 0).getDate();
      for (var i = 1; i <= days_in_month; i++) {
        var date = new Date(this.state.currentYear, m, i);
        if (date.getDay() == day) {
          let day_value = this.state.currentYear + "-" + (m + 1) + "-" + date.getDate();
          if (!this.isChecked(day_value)) {
            days.push(day_value);
          }
        }
      }
    }

    this.setState({
      offDays: days
    });
    this.props.postCalendar(days);
  };

  addDay = (val) => {
    let days = this.state.offDays;
    if (!this.isChecked(val)) {
      days.push(val);
      this.setState({
        offDays: days
      });
      this.props.postCalendar(days);
    }
  };

  removeDay = (val) => {
    let days = this.state.offDays;
    if (this.isChecked(val)) {
      days = days.filter(function (day) {
        return day !== val
      });
      this.setState({
        offDays: days
      });
      this.props.postCalendar(days);
    }
  };

  selectSaturdays = () => {
    this.selectDays(6);
  };

  selectSundays = () => {
    this.selectDays(0);
  };

  currentYear = () => {
    return new Date().getFullYear();
  };

  setYear = (year) => {
    this.setState({ currentYear: year });
  };

  isChecked = (val) => {
    return this.state.offDays.includes(val);
  };

  setChecked = (e) => {
    if (e.target.checked === true) {
      this.addDay(e.target.value);
    } else {
      this.removeDay(e.target.value);
    }
  };


  render() {
    return (
      <Container
        location={{
          locationName: "Calendar " + this.state.currentYear,
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <AlertError alertId={"calendar-e"} />
          <div className="p-3 calendar-header">
            Select day off days in calendar below. These dys will not be displayed in available delivery date.
          </div>
          <div className="row p-3 calendar-buttons">
            <div className="col-md-6 mb-3">
              Mark all: <a href="#" className="" onClick={this.selectSaturdays}>Saturday</a> | <a href="#" className="" onClick={this.selectSundays}>Sunday</a>
            </div>
            <div className="col-md-6 mb-3 text-right">
              Year:
              <button
                className={`btn btn-sm ${this.state.currentYear === this.currentYear() ? 'btn-primary' : 'btn-outline-primary'} mr-1`}
                onClick={() => this.setYear(this.currentYear())}
              >
                {this.currentYear()}
              </button>
              <button
                className={`btn btn-sm ${this.state.currentYear === this.currentYear() + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => this.setYear(this.currentYear() + 1)}
              >
                {this.currentYear() + 1}
              </button>
            </div>
          </div>
          <table className="table table-bordered calendar-table">
            <thead>
              <tr>
                {this.getMonths().map((item, i) => <th key={i}>{item}</th>)}
              </tr>
            </thead>
            <tbody>
              <tr>
                {this.getMonths().map((item, i) =>
                  <td key={"month-" + (i + 1)}>
                    {this.getDaysInMonth(i, this.state.currentYear).map((day, day_i) =>
                      <label className={`calendar-day ${this.isChecked(this.state.currentYear + "-" + (i + 1) + "-" + day[0]) ? "active" : ""} ${day[1] ? "weekend" : ""}`} key={"label-" + this.state.currentYear + "" + (i + 1) + "" + day[0]}>
                        <input type="checkbox"
                          checked={this.isChecked(this.state.currentYear + "-" + (i + 1) + "-" + day[0])}
                          value={this.state.currentYear + "-" + (i + 1) + "-" + day[0]}
                          onChange={this.setChecked}
                        />
                        <span>{day[0]}</span>
                      </label>
                    )}
                  </td>
                )
                }
              </tr>
            </tbody>
          </table>
        </ContentBlock>

      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  offDays: state.calendar.offDays,
  loading_calendar: state.calendar.loading_calendar,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getCalendar,
  postCalendar,
})(Calendar);
